import { useEffect, useMemo, useState } from "react";
import { Search } from "lucide-react";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Reveal } from "@/components/Reveal";

export default function Tienda() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("novedades");

  useEffect(() => {
    setLoading(true);
    api
      .get("/productos")
      .then((r) => setProducts(r.data))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, []);

  const visible = useMemo(() => {
    let list = products.filter((p) =>
      search.trim() ? p.name.toLowerCase().includes(search.trim().toLowerCase()) : true
    );
    if (sort === "precio_asc") list = [...list].sort((x, y) => x.price - y.price);
    if (sort === "precio_desc") list = [...list].sort((x, y) => y.price - x.price);
    return list;
  }, [products, search, sort]);

  return (
    <main className="mx-auto max-w-7xl px-5 pb-24 pt-32 sm:px-8 lg:pt-40">
      <Reveal>
        <p className="font-mono text-[11px] uppercase tracking-widest text-volt">MM Store · Buenos Aires</p>
        <h1 className="mt-2 font-display text-5xl font-black uppercase tracking-tight text-white sm:text-6xl">
          Catálogo
        </h1>
      </Reveal>

      <div className="mt-8 flex flex-col gap-4 border-y border-white/10 py-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="font-mono text-xs uppercase tracking-widest text-zinc-500" data-testid="catalog-count">
          {loading ? "Cargando..." : `${visible.length} productos`}
        </p>
        <div className="flex flex-col gap-3 sm:flex-row">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-zinc-500" />
            <input
              data-testid="catalog-search-input"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Buscar producto..."
              className="w-full border border-white/15 bg-panel py-2.5 pl-10 pr-4 text-sm text-white placeholder:text-zinc-600 outline-none focus:border-volt sm:w-56"
            />
          </div>
          <select
            data-testid="catalog-sort-select"
            value={sort}
            onChange={(e) => setSort(e.target.value)}
            className="border border-white/15 bg-panel px-4 py-2.5 text-sm text-white outline-none focus:border-volt"
          >
            <option value="novedades">Novedades</option>
            <option value="precio_asc">Menor precio</option>
            <option value="precio_desc">Mayor precio</option>
          </select>
        </div>
      </div>

      {loading ? (
        <div className="mt-8 grid grid-cols-2 gap-4 lg:grid-cols-4">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="aspect-[3/4] animate-pulse bg-panel" />
          ))}
        </div>
      ) : visible.length === 0 ? (
        <div className="mt-16 border border-dashed border-white/15 py-20 text-center">
          <p className="font-display text-2xl font-black uppercase text-zinc-400">No encontramos productos</p>
          <p className="mt-2 text-sm text-zinc-500">Probá con otra búsqueda o categoría.</p>
        </div>
      ) : (
        <div className="mt-8 grid grid-cols-2 gap-4 lg:grid-cols-4">
          {visible.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} />
          ))}
        </div>
      )}
    </main>
  );
}
